import { useState, useMemo } from "react";
import { ISearchResultsMutationVariables, useSearchResults } from "src/components-mui/common/typeahead/hooks/use-search-results";
import { getCombinedResults } from "src/components-mui/common/typeahead/utils";
import { sanitizeSearchTerm } from "src/utils/sanitize-search-term";

export const useQueryWithSearchResults = (mutationVariables?: ISearchResultsMutationVariables) => {
    const [query, setQuery] = useState("");

    const { results, flushResults } = useSearchResults({ queryValue: sanitizeSearchTerm(query), mutationVariables });

    const combinedResults = useMemo(() => getCombinedResults(results), [results]);

    const onClear = () => {
        flushResults();
        setQuery("");
    };

    return {
        query,
        setQuery,
        onClear,
        results,
        combinedResults,
    };
};
